import { Action } from '@ngrx/store';

import { FunctionalityAction, FunctionalityActionTypes } from '@actions/functionality.action';
import { FetchFromLocalStorage } from '@common/helpers/fetch-from-local-storage.helper';

import { FunctionalityState } from 'state';

const emptyState: FunctionalityState = {
    functionalities: {
        approveClosingSeries: false,
        deleteSeries: false,
        editSeries: false,
        initializeSeriesReview: false,
        writeSeriesConclusion: false,
        assignSeriesForEvaluation: false,
        closeSeries: false,
        createSeries: false,
        createTemplateSeries: false,
        evaluateSeries: false,
        exportPublishedSeriesInformationManagementPlansSelectionList: false,
        importSeries: false,
        submitSeries: false,
        viewGroups: false,
        adminOrganisation: false,
        adminGroups: false,
        adminSecurity: false,
        adminExtensions: false,
        adminFieldDefinitions: false,
        editRelations: false,
        viewSeries: false,
        viewUnpublishedSeries: false,
        viewReports: false,
        createDossiers: false
    }
};

export const initialState: FunctionalityState = FetchFromLocalStorage('functionality') || emptyState;

export function reducer(state = initialState, action: Action): FunctionalityState {
    const specificAction: FunctionalityAction = action as FunctionalityAction;
    switch (specificAction.type) {
        case FunctionalityActionTypes.SetFunctionalities:
            return { ...state, functionalities: specificAction.payload };

        case FunctionalityActionTypes.UnsetFunctionalities:
            return { ...emptyState };

        default:
            return state;
    }
}
